package com.klantenstop.web.data.models.dto.requests.status

import com.klantenstop.web.data.models.domain.Status
import kotlinx.serialization.Serializable

@Serializable
data class InsertStatus(
    val text: String = "",
    val status: Status.Type = Status.Type.Unknown,
    val companyId: String = ""
) {
    val isValid
        get() = companyId.isNotBlank()
}
